export default __webpack_public_path__ + "static/media/rocket-azure.3eaa4b16.svg";